import { app } from '../../../../../app';
import { Controller } from './sms-settings.controller';

app.component('companySmsServicesHelpSmsSettings', {
    controller: Controller,
    templateUrl: require('./sms-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-settings/sms-settings.component.js